import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Store from './Reducers/Store';
import { setupAnalytics } from './Utils/GoogleAnalytics';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './Assets/Css/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

setupAnalytics();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Store>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Store>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
